(function () {
  function initSlider(slider) {
    var track = slider.querySelector('[data-cr-team-track]');
    var prev = slider.querySelector('[data-cr-team-prev]');
    var next = slider.querySelector('[data-cr-team-next]');

    if (!track || !prev || !next) {
      return;
    }

    function getStep() {
      var card = track.querySelector('.cr-team__card');
      var gap = parseFloat(window.getComputedStyle(track).columnGap || 0);

      return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    }

    function updateButtons() {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;

      if (maxScroll <= 0) {
        prev.hidden = true;
        next.hidden = true;
        return;
      }

      prev.hidden = track.scrollLeft <= 2;
      next.hidden = track.scrollLeft >= maxScroll;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  }

  function initCustomerReviewTeam() {
    document.querySelectorAll('[data-cr-team-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomerReviewTeam);
  } else {
    initCustomerReviewTeam();
  }
})();
